export enum IncorporationPartnerEnum {
  astro = 'astro',
  other = 'other',
}

export type IncorporationPartner = keyof typeof IncorporationPartnerEnum;

export enum IncorporationStatusEnum {
  completed = 'completed',
  needed = 'needed',
}

export type IncorporationStatus = keyof typeof IncorporationStatusEnum;
